import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { connect } from 'react-redux';
import { CART_TYPE } from '../../../../../../common/types';

import SummarySellerTiles from './SellerTiles';

type Props = {
    isOrderTypeSchool: boolean;
}

const SummarySellerPanel: React.FC<Props> = ({ isOrderTypeSchool}) => {
    return (
        <SummarySellerTiles renderHeader={isOrderTypeSchool ? "Sprzedawca (Podmiot 1)" : "Sprzedawca"}>
            <Grid container
                  direction="column">
                <Typography variant="subtitle1">
                    Gdańskie Wydawnictwo Oświatowe spółka z ograniczoną odpowiedzialnością sp. k.
                </Typography>
                <span>Al. Grunwaldzka 50A, 80-241 Gdańsk</span>
                <Typography variant="caption">
                    NIP: 5841000656 <br />
                    e-mail: <Link href="mailto:zamowienia@gwo.pl">zamowienia@gwo.pl</Link><br />
                    telefon: 58 340 63 63
                </Typography>
            </Grid>
        </SummarySellerTiles>
    );
};

type MappingType = {
    checkout: {
        values: any;
    };
};

const mapStateToProps = ({ checkout }: MappingType) => ({
    isOrderTypeSchool: checkout.values?.orderType === CART_TYPE.SCHOOL,
});

export default connect(mapStateToProps)(SummarySellerPanel);
